import React from 'react';
import { useTheme, type ThemeId } from '../theme/theme';
import { ArrowLeftIcon, BellIcon, HelpIcon, HomeIcon, SearchIcon, type IconProps } from './icons';
import { useIconStyle } from './iconStyle';

export type TopIconName = 'back' | 'home' | 'notifications' | 'search' | 'help';

/**
 * 帮助图标资源此前按错误的主题后缀生成，按实际视觉语言重新对齐主题。
 * 其他顶部图标仍然使用同名主题资源。
 */
const HELP_ICON_THEME_MAP: Record<ThemeId, ThemeId> = {
  'maitian': 'maitian',
  dream: 'dream',
  starlight: 'starlight',
  custom: 'custom',
};

export function topIconPath(theme: ThemeId, name: TopIconName): string {
  const assetTheme = name === 'help' ? HELP_ICON_THEME_MAP[theme] : theme;
  return `/generated-icons/top-${name}-${assetTheme}.png`;
}

export interface TopIconProps {
  name: TopIconName;
  size: number;
  className?: string;
}

const STANDARD_TOP_ICONS: Record<TopIconName, React.ComponentType<IconProps>> = {
  back: ArrowLeftIcon,
  home: HomeIcon,
  notifications: BellIcon,
  search: SearchIcon,
  help: HelpIcon,
};

export const TopIcon: React.FC<TopIconProps> = ({ name, size, className }) => {
  const { theme } = useTheme();
  const { iconStyle } = useIconStyle();

  if (iconStyle === 'standard-svg') {
    const Icon = STANDARD_TOP_ICONS[name];
    return <Icon className={className} size={size} aria-hidden="true" data-icon-style-rendered="svg" />;
  }

  return (
    <img
      className={className}
      src={topIconPath(theme, name)}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      data-icon-style-rendered="theme-image"
    />
  );
};

export default TopIcon;
